// import get from 'lodash/get';
import { TState } from '~/src/store';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectDomain(state: TState): string {
   return 'stelecom';
   // return get(state, 'auth.billingDomain') || get(state, 'city.currentCity.domain');
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectHostname(state: TState): string {
   return 'stelecom.db.ertelecom.ru';
   // const domain = get(state, 'auth.billingDomain');
   //
   // if (domain && domain !== 'interzet') {
   //    return 'https://' + domain + '.db.ertelecom.ru';
   // } else {
   //    return get(state, 'city.currentCity.billingHost');
   // }
}
